import { Component, OnInit, Injector, Input, } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component ({
    selector: 'custom-textarea',
    host: { '[class]': 'myCustomClass' },
    template:`
    <textarea
    [(ngModel)]="value"
    (blur)="setAnswer(value)"
    [ngClass]="{ disabled: control.disabled, error: !!error }"
    maxlength="{{ control.attributes.maxlength }}"
    [disabled]="control.disabled"
    (change)="onChange()"
    [attr.gtm]="gaLabel"
    >
</textarea>
    `,
    styleUrls : ['./custom-textarea.component.scss']
})

export class CustomTextAreaComponent extends EventsComponent implements OnInit {
 constructor(injector : Injector){
     super(injector)
 }

 ngOnInit() {
  this.gaLabel = this.getGaLabel(this.control);
  if(this.value){
    this.reportPrefill();
  }
}

 onChange() {
    this.updateAnswer();
    // if (this.control.onChange) {
    //   this.control.onChange(this.value);
    // }
  }

  updateAnswer() {
    // clean commas if groupDigits is set to  true
    const strippedValue = this.control.attributes.groupDigits
      ? this.stripCommas(this.value)
      : this.value;

    this.setAnswer(strippedValue);
  }

  stripCommas(value) {
    if (typeof value === 'undefined') {
      return value;
    }

    // remove regex matched chars from value
    return String(value).replace(/,/g, '');
  }
}
